import type { InitialState } from './types';

export const INITIAL_STATE_VERSION = 2;

interface StoredState {
  version: number;
  data: InitialState;
  timestamp: number;
}

export function saveInitialState(state: InitialState): void {
  if (typeof localStorage === 'undefined') return;

  const versionedState: StoredState = {
    version: INITIAL_STATE_VERSION,
    data: state,
    timestamp: Date.now(),
  };
  localStorage.setItem('initial_state', JSON.stringify(versionedState));
}

export function loadInitialState(): InitialState | null {
  if (typeof localStorage === 'undefined') return null;

  const stored = localStorage.getItem('initial_state');
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored) as StoredState;

    if (parsed.version !== INITIAL_STATE_VERSION) {
      console.warn(
        `Initial state version mismatch (stored: ${parsed.version}, current: ${INITIAL_STATE_VERSION})`,
      );
      return null;
    }

    return parsed.data;
  } catch (error) {
    console.error('Failed to parse stored initial state:', error);
    return null;
  }
}

export function clearInitialState(): void {
  if (typeof localStorage === 'undefined') return;

  localStorage.removeItem('initial_state');
}
